import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  StudentScoreList,
  StudentScoreListBackend,
  mapDashPayload,
} from 'src/config/api/models/Score';
import apiRoutesV2, { baseURL } from 'src/config/api/routes';
import { RootState } from 'src/modules/shared/store';

type getDashboardParams = {
  trajectoryId: string;
  groupId: string;
  selectedAttemptFilter: string;
};

export const dashboardApi = createApi({
  reducerPath: 'dashboardApi',
  baseQuery: fetchBaseQuery({
    baseUrl: baseURL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.jwt;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getScoring: builder.query<StudentScoreList, getDashboardParams>({
      query: ({ trajectoryId, groupId, selectedAttemptFilter }: getDashboardParams) => ({
        url: apiRoutesV2.getTrajectoryScoring(trajectoryId, groupId, selectedAttemptFilter),
        method: 'GET',
      }),
      transformResponse: (response: { data: StudentScoreListBackend }) => mapDashPayload(response),
    }),
  }),
});

export const { useGetScoringQuery } = dashboardApi;
